import React from 'react';
import { Button } from 'components/Button';
import { Modal } from 'components/Modal';
import styles from 'css_modules/DuplicateModal.module.css';
import { formatDate } from 'helpers/tools';

export const AccYearWarningModal = ({
  allDocs,
  clickedClose,
  clickedOkAll,
  clickedOkCurrentYearOnly,
  currentYears
}) => {
  
  if (typeof allDocs === 'string') {
    return (
      <div className={styles.ontop}>
        <Modal name="Doklad mimo aktuální účetní rok" close={clickedClose}>
          <main className={styles.body}>
            <p>
              Doklad nemá nastavený aktuální účetní rok klientské společnosti.
            </p>
          </main>
          <footer
            style={{
              margin: '1rem',
              display: 'flex',
              justifyContent: 'space-between',
              gap: '0.5rem',
            }}
          >
            <Button onClick={clickedClose} style={{ flex: '0 0 auto' }}>
              Zrušit
            </Button>
            <Button primary onClick={clickedOkAll} style={{ flex: '0 0 auto' }}>
              Odeslat
            </Button>
          </footer>
        </Modal>
      </div>
    );
  }

  let wrongYearDocs = allDocs.filter(doc => doc.accounting_year !== currentYears.find(c => c.client_company === doc.document_info.client_company).year);

  return (
    <div className={styles.ontop}>
      <Modal name="Doklady mimo aktuální účetní rok" close={clickedClose}>
        <main className={styles.body}>
          <p style={{ marginBottom: '1rem' }}>
            Následující doklady mají nastavený jiný účetní rok než aktuální rok klientské společnosti:
          </p>

          <table className={styles.table}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Popis dokladu</th>
                <th>Účetní rok</th>
                <th>Vytvořil</th>
              </tr>
            </thead>
            <tbody>
              {wrongYearDocs.map(doc => {
                const url = `/${doc.location}/${doc.uuid}/metadata`;
                const lastModified = `${formatDate(doc.last_modified) || '---'} (${doc.added_by_user || doc.added_by || '---'})`;
                const identifier = doc.document_info?.document_identifier || '-';

                return (
                  <tr key={doc.uuid}>
                    <td>
                      {doc.location ? (
                        <a href={url} target="_blank" rel="noreferrer">
                          {doc.uuid}
                        </a>
                      ) : (
                        <span>{doc.uuid}</span>
                      )}
                    </td>
                    <td>
                      {doc.location ? (
                        <a href={url} target="_blank" rel="noreferrer">
                          {identifier}
                        </a>
                      ) : (
                        <span>{identifier}</span>
                      )}
                    </td>
                    <td>{doc.accounting_year || '-'}</td>
                    <td>{lastModified}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </main>

        <footer
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr auto auto',
            gap: '0.5rem',
            alignItems: 'center',
            margin: '1rem',
          }}
        >
          <Button onClick={clickedClose} style={{ width: '100%' }}>
            Zrušit
          </Button>
          <div />
          {wrongYearDocs.length > 0 && allDocs.length - wrongYearDocs.length !== 0 ? (
            <>
              <Button onClick={clickedOkCurrentYearOnly} style={{ width: '100%' }}>
                Odeslat jen doklady s aktuálním rokem ({allDocs.length - wrongYearDocs.length})
              </Button>
              <Button primary onClick={clickedOkAll} style={{ width: '100%' }}>
                {allDocs.length === 1 ? 'Odeslat' : `Odeslat vše (${allDocs.length})`}
              </Button>
            </>
          ) : (
            <>
              <div />
              <Button primary onClick={clickedOkAll} style={{ width: '100%' }}>
                {allDocs.length === 1 ? 'Odeslat' : `Odeslat vše (${allDocs.length})`}
              </Button>
            </>
          )}
        </footer>
      </Modal>
    </div>
  );
};
